const TaraSlider = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      let params = $el.data('slider-params');
      if (!params) {
        params = {};
      }
      params.prevArrow = '<button class="slick-arrow slick-prev"><i class="icon icon-arrow"></i></button>';
      params.nextArrow = '<button class="slick-arrow slick-next"><i class="icon icon-arrow"></i></span></button>';
      initSlider($el, params);
    });
}

export default TaraSlider;



// WEBPACK FOOTER //
// ./scripts/components/TaraSlider.js